import React from 'react';
import {Images, noteStatusEnums, PermissionList, RolePermission} from 'utils';
import {ApptDetailRow, DateRow, DateRowStartEnd, LinkRow, TextRow, ToolInfo, TypeRow} from 'components';
import {NoteMoreActions} from './noteMoreActions';
import {NoteStatusBadge} from '../../../../schedule/core/modals/apptDetail/constants';
import moment from 'moment/moment';

export const clientNoteEnums = {
    NOTE: 'NOTE',
    PROGRESS_REPORT: 'PROGRESS_REPORT',
    CLIENT_INTAKE: 'CLIENT_INTAKE',
    APPT_SESSION_NOTE: 'APPT_SESSION_NOTE',
    APPT_OFFICE_NOTE: 'APPT_OFFICE_NOTE',
    ABC_NOTE: 'ABC_NOTE',
    INVITED: 'INVITED',
};

export const CLIENT_DOCUMENT_ACTION_TYPE = 'GET_CLIENT_ALL_NOTES';

export const clientDocumentHead = [
    {
        name: 'types',
        title: 'Type',
        disabled: true,
        multiple: true,
        filterList: [
            { name: 'All', id: 'All' },
            { name: 'Client Note', id: clientNoteEnums.NOTE },
            { name: 'Session Note', id: clientNoteEnums.APPT_SESSION_NOTE },
            { name: 'Progress Report', id: clientNoteEnums.PROGRESS_REPORT },
            { name: 'Intake', id: clientNoteEnums.INVITED },
            { name: 'Abc Data', id: clientNoteEnums.ABC_NOTE },
        ],
    },
    // The document's own title (note name / report title, else the template's) —
    // `title` is resolved per type by the API, so rows can be told apart without the ⋯ menu.
    {name: 'templateTitle', title: 'Template', custom: false},
    {name: 'title', title: 'Title', custom: false},
    {name: 'created', title: 'Created At', iconType: 'date'},
    {name: '', title: 'Created By', custom: false},
    {name: '', title: 'Details', custom: false},
    {name: 'action', title: 'Actions', custom: false, disabled: true, width: '90px'},
];

export const clientDocumentBody = (afterSuccess, requestParams) => {
    return [
        {
            rowText: (item) => {
                return (
                    <div>
                        {item?.type === clientNoteEnums.PROGRESS_REPORT ? (
                            <div className="flex-align-center" style={{gap: 8}}>
                                <div className="type-card-box progress-report">
                                    <img src={Images.clientProggressReport} alt="noteType"/>
                                    <p>Progress Report</p>
                                </div>
                                {/* Only drafts are flagged; a finalized report is the norm. */}
                                {item?.status === noteStatusEnums.DRAFT && <NoteStatusBadge status={item.status} doNotShowIcon/>}

                                {/*<div style={{ marginTop: 5 }}>*/}
                                {/*    <ToolInfo*/}
                                {/*        text={`Date Range: ${moment.utc(item?.startDate).format('MM/DD/YYYY')} - ${moment*/}
                                {/*            .utc(item?.endDate)*/}
                                {/*            .format('MM/DD/YYYY')}`}*/}
                                {/*    />*/}
                                {/*</div>*/}
                            </div>
                        ) : item?.type === clientNoteEnums.NOTE ? (
                            <div className="type-card-box client-notes">
                                <img src={Images.clientNotesDock} alt="noteType"/>
                                <p>Client Note</p>
                            </div>
                        ) : item?.type === clientNoteEnums.APPT_SESSION_NOTE ? (
                                <div className="flex-align-center" style={{gap: 8}}>
                                    <div className="type-card-box session-notes">
                                        <img src={Images.clientSessionNotesDock} alt="noteType"/>
                                        <p>Session Note</p>
                                    </div>
                                    {/*<div style={{ marginTop: 5 }}>*/}
                                    {/*    <SimpleTooltip*/}
                                    {/*        placement="top-start"*/}
                                    {/*        title={*/}
                                    {/*            <div>*/}
                                    {/*                <p>{`Appt ID: ${item?.apptDisplayId}`}</p>*/}
                                    {/*                <p style={{ marginTop: 4 }}>*/}
                                    {/*                    {`Status: `}*/}
                                    {/*                    <NoteStatusBadge status={item?.status} doNotShowIcon={true} />*/}
                                    {/*                </p>*/}
                                    {/*            </div>*/}
                                    {/*        }>*/}
                                    {/*        <img src={Images.toolInfoIcon} alt={'icon'} />*/}
                                    {/*    </SimpleTooltip>*/}
                                    {/*</div>*/}
                                </div>
                            ) :
                            item?.type === clientNoteEnums.ABC_NOTE ? (
                                    <div className="type-card-box abc-data">
                                        <img src={Images.clientAbcData} alt="noteType"/>
                                        <p>ABC Data</p>
                                    </div>
                                )
                                :
                                (
                                    <div className="type-card-box other-notes">
                                        <img
                                            style={{
                                                filter: 'brightness(0) saturate(100%) invert(26%) sepia(28%) saturate(6211%) hue-rotate(18deg) brightness(94%) contrast(94%)',
                                            }}
                                            src={Images.clientNotesDock}
                                            alt="noteType"
                                        />
                                        <p>
                                            <TypeRow text={item?.type}/>
                                        </p>
                                    </div>
                                )}
                    </div>
                );
            },
        },
        {
            rowText: (item) => <TextRow name={item?.templateTitle}/>,
        },
        {
            rowText: (item) => <TextRow name={item?.title}/>,
        },
        {
            rowText: (item) => <DateRow date={item?.createdAt}/>,
        },
        {
            rowText: (item) =>
                item?.createdByFullName && item?.createdById ? (
                    <LinkRow
                        name={item?.createdByFullName}
                        href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${item?.createdById}` : ''}
                        checkPermission={item?.createdById ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                        defaultColor={'#172B4D'}
                    />
                ) : (
                    <TextRow name={item?.createdByFullName}/>
                ),
        },


        {
            rowText: (item) => {
                return (
                    <div>
                        {
                            item?.type === clientNoteEnums.PROGRESS_REPORT ? (
                                <div className="flex-align-center" style={{gap: 2, fontSize: 14}}>
                                    <p>Date Range: </p>
                                    <DateRowStartEnd start={item?.startDate} end={item?.endDate}/>
                                </div>
                            ) : item?.type === clientNoteEnums.APPT_SESSION_NOTE ? (
                                    <div>
                                        {item?.apptStartDate && (
                                            <div style={{fontSize: 14}}>
                                                <p>{`Session ${moment(item?.apptStartDate).format('MM/DD')}`}</p>
                                            </div>
                                        )}

                                        <div className="flex-align-center" style={{gap: 8}}>
                                            {item?.apptDisplayId && item?.apptId && (
                                                <div className="flex-align-center" style={{gap: 2, fontSize: 14}}>
                                                    <p>Appt: </p>
                                                    <div onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                    }}>
                                                        <ApptDetailRow name={item?.apptDisplayId} id={item?.apptId}
                                                                       showWidth={'auto'}/>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="flex-align-center" style={{gap: 2, fontSize: 14}}>
                                                <p>Staff: </p>
                                                {item?.apptStaffFullName && item?.apptStaffId ? (
                                                    <LinkRow
                                                        name={item?.apptStaffFullName}
                                                        href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${item?.apptStaffId}` : ''}
                                                        checkPermission={
                                                            item?.apptStaffId ? RolePermission([PermissionList.STAFF_READ.code]) : null
                                                        }
                                                        defaultColor={'#172B4D'}
                                                    />
                                                ) : (
                                                    <TextRow name={item?.apptStaffFullName}/>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) :
                                item?.type === clientNoteEnums.ABC_NOTE ? (
                                        <div>
                                            {item?.apptStartDate && (
                                                <div style={{fontSize: 14}}>
                                                    <p>{`Session ${moment(item?.apptStartDate).format('MM/DD')}`}</p>
                                                </div>
                                            )}
                                            <div className="flex-align-center" style={{gap: 8}}>
                                                {item?.apptDisplayId && item?.apptId && (
                                                    <div className="flex-align-center" style={{gap: 2, fontSize: 14}}>
                                                        <p>Appt: </p>
                                                        <div onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                        }}>
                                                            <ApptDetailRow name={item?.apptDisplayId} id={item?.apptId} showWidth={'auto'}/>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )
                                    :
                                    (
                                        <div>--</div>
                                    )}
                    </div>
                );
            },
        },

        {
            rowText: (item) => <NoteMoreActions item={item} afterSuccess={afterSuccess} requestParams={requestParams}/>,
        },
    ];
};

export const documentNotYet = {
    title: 'No Documents Added',
    subTitle: 'It looks like there are currently no documents listed. ',
    image: Images.notFile,
};
